import { emptySplitApi } from './index'

export const smartPhrasesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getPhrasesByDocumentType: builder.query({
      query: (documentType) => ({
        url: `api/v1/document-generator-service/suggested-phrase/by-document-type/${documentType}`,
        method: "GET"
      }),
      providesTags: ['SmartPhrases'],
      transformResponse: (response) => {
        // Backend returns { phrases: [...], totalCount: number }
        // Return just the phrases array for easier consumption
        return response.phrases || response;
      }
    }),
    trackPhraseUsage: builder.mutation({
      query: (phraseId) => ({
        url: `api/v1/document-generator-service/suggested-phrase/increment-usage`,
        method: "POST",
        body: { phraseId }
      }),
    }),
    // Admin endpoints
    getAllPhrases: builder.query({
      query: () => ({
        url: `api/v1/document-generator-service/suggested-phrase`,
        method: "GET"
      }),
      providesTags: ['SmartPhrases'],
      transformResponse: (response) => {
        return response.phrases || response;
      }
    }),
    getPagedPhrases: builder.query({
      query: (params) => ({
        url: `api/v1/document-generator-service/suggested-phrase/paged`,
        method: "GET",
        params: {
          PageNumber: params.pageNumber || 0,
          PageSize: params.pageSize || 10,
          OrderField: params.orderField || 'UsedCount',
          OrderDirection: params.orderDirection || 'desc',
          SearchTerm: params.searchTerm || '',
          DocumentType: params.documentType || ''
        }
      }),
      providesTags: ['SmartPhrases'],
    }),
    getPagedPhrasesByDocumentType: builder.query({
      query: ({ documentType, ...params }) => ({
        url: `api/v1/document-generator-service/suggested-phrase/by-document-type/${documentType}/paged`,
        method: "GET",
        params: {
          PageNumber: params.pageNumber || 0,
          PageSize: params.pageSize || 10,
          OrderField: params.orderField || 'UsedCount',
          OrderDirection: params.orderDirection || 'desc'
        }
      }),
      providesTags: ['SmartPhrases'],
    }),
    createPhrase: builder.mutation({
      query: (phrase) => ({
        url: `api/v1/document-generator-service/suggested-phrase`,
        method: "POST",
        body: phrase
      }),
      invalidatesTags: ['SmartPhrases'],
    }),
    updatePhrase: builder.mutation({
      query: ({ id, ...phrase }) => ({
        url: `api/v1/document-generator-service/suggested-phrase/${id}`,
        method: "PATCH",
        body: phrase
      }),
      invalidatesTags: ['SmartPhrases'],
    }),
    deletePhrase: builder.mutation({
      query: (id) => ({
        url: `api/v1/document-generator-service/suggested-phrase/${id}`,
        method: "DELETE"
      }),
      invalidatesTags: ['SmartPhrases'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPhrasesByDocumentTypeQuery,
  useTrackPhraseUsageMutation,
  useGetAllPhrasesQuery,
  useGetPagedPhrasesQuery,
  useGetPagedPhrasesByDocumentTypeQuery,
  useCreatePhraseMutation,
  useUpdatePhraseMutation,
  useDeletePhraseMutation,
} = smartPhrasesApi;
